var chunkMapping = {
	"330": [
		20330
	],
	"1060": [
		11060
	],
	"1538": [
		71538
	],
	"2131": [
		52131
	],
	"3033": [
		53033
	],
	"3270": [
		3270
	],
	"3469": [
		53469
	],
	"4257": [
		64257
	],
	"4656": [
		44656
	],
	"4911": [
		14911
	],
	"5136": [
		25136
	],
	"6276": [
		46276
	],
	"8395": [
		88395
	],
	"9647": [
		42028
	],
	"9650": [
		9650
	]
};
var idToExternalAndNameMapping = {
	"3270": [
		"default",
		"./FederatedReducers",
		44197
	],
	"9650": [
		"default",
		"./BetaProjectReport",
		44197
	],
	"11060": [
		"default",
		"./ActivitiesScreen",
		44197
	],
	"14911": [
		"default",
		"./AutoDialerScreen",
		31548
	],
	"20330": [
		"default",
		"./WhatsappPro",
		44197
	],
	"25136": [
		"default",
		"./BottomNavigation",
		44197
	],
	"42028": [
		"default",
		"./layout-slice",
		44197
	],
	"44656": [
		"default",
		"./WeekView",
		44197
	],
	"46276": [
		"default",
		"./BetaProjectListing",
		44197
	],
	"52131": [
		"default",
		"./BetaReviewReport",
		44197
	],
	"53033": [
		"default",
		"./BetaDigitalReport",
		44197
	],
	"53469": [
		"default",
		"./FollowupForm",
		44197
	],
	"64257": [
		"default",
		"./BetaReviewReportLeadList",
		44197
	],
	"71538": [
		"default",
		"./ProjectReportLeadList",
		44197
	],
	"88395": [
		"default",
		"./FollowUpScreen",
		44197
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}